import React from 'react'

import {ReserveReservationApplicationErrorCode} from '../../actions/reserveReservation'
import {ErrorModal} from '../../../../components-shared/ErrorModal'
import {isResolvedError} from '../../../../utils/errors'

import {useHooks} from './useHooks'

interface Texts {
  title: string
  text: string
  ctaButton: string
}

const DEFAULT_TEXTS: Texts = {
  title: 'uou-reservations.reservation-details.error-modal.title',
  text: 'uou-reservations.reservation-details.error-modal.text',
  ctaButton: 'uou-reservations.reservation-details.error-modal.cta',
}

const APPLICATION_ERROR_CODE_TO_TEXTS: Record<ReserveReservationApplicationErrorCode, Texts> = {
  [ReserveReservationApplicationErrorCode.HELD_EXPIRED]: {
    title: 'uou-reservations.reservation-details.held-modal.title',
    text: 'uou-reservations.reservation-details.held-expired-error',
    ctaButton: 'uou-reservations.reservation-details.held-modal.cta',
  },
  [ReserveReservationApplicationErrorCode.TOO_MANY_REQUESTS]: {
    title: 'uou-reservations.reservation-details.too-many-requests-modal.title',
    text: 'uou-reservations.reservation-details.too-many-requests-error',
    ctaButton: 'uou-reservations.reservation-details.too-many-requests-modal.cta',
  },
}

export const ReservationErrorModal: React.FC = () => {
  const {isModalOpen, onClose, onCtaButtonClick, apiRequestErrorDetails} = useHooks()

  if (!apiRequestErrorDetails) {
    return null
  }

  const getErrorTexts = () => {
    if (isResolvedError(apiRequestErrorDetails)) {
      if (apiRequestErrorDetails.applicationError?.code) {
        return {
          title:
            APPLICATION_ERROR_CODE_TO_TEXTS[apiRequestErrorDetails.applicationError.code]?.title ??
            DEFAULT_TEXTS.title,
          text: apiRequestErrorDetails?.message || DEFAULT_TEXTS.text,
          ctaButton:
            APPLICATION_ERROR_CODE_TO_TEXTS[apiRequestErrorDetails.applicationError.code]
              ?.ctaButton ?? DEFAULT_TEXTS.ctaButton,
        }
      }
    }

    return DEFAULT_TEXTS
  }

  const {title, text, ctaButton} = getErrorTexts()

  return (
    <ErrorModal
      isModalOpen={isModalOpen}
      title={title}
      text={text}
      ctaButton={ctaButton}
      onClose={onClose}
      onCtaButtonClick={onCtaButtonClick}
    />
  )
}
